import React, { useEffect, useState } from 'react'
import { SimpleBluePink } from './SimpleBluePink'
import { BlueSphereTop } from './BlueSphereTop'
import { BlueOrangeSphereLeftTop } from './BlueOrangeSphereLeftTop'
import { MessyHorizontal } from './MessyHorizontal'
import { BlueSphereRightTop } from './BlueSphereRightTop'
import { CutBlueSphereTop } from './CutBlueSphereTop'
import { BluePinkSphereCenter } from './BluePinkSphereCenter'
import { VibrantPinkInBlue } from './VibrantPinkInBlue'
import { SimpleBlue } from './SimpleBlue'
import { SimpleBeige } from './SimpleBeige'
import { SimpleTurquoise } from './SimpleTurquoise'
import { VibrantWhitePinkInBlue } from './VibrantWhitePinkInBlue'
import { WhitePinkBlueSpheres } from './WhitePinkBlueSpheres'
import { useIntl } from 'react-intl'
import { OrangeInBlueMasked } from './OrangeInBlueMasked'
import { BluePinkInOrange } from './BluePinkInOrange'

export const SuperGradientBackground = ({
  type,
  hideGrain,
  className,
  style,
  ...props
}: {
  type:
    | 'simple-blue'
    | 'simple-beige'
    | 'simple-turquoise'
    | 'simple-blue-pink'
    | 'blue-sphere-top'
    | 'cut-blue-sphere-top'
    | 'blue-orange-sphere-left-top'
    | 'messy-horizontal'
    | 'blue-sphere-right-top'
    | 'blue-pink-sphere-center'
    | 'blue-pink-in-orange'
    | 'vibrant-pink-in-blue'
    | 'vibrant-white-pink-in-blue'
    | 'white-pink-blue-spheres'
    | 'orange-in-blue-masked'

  hideGrain?: boolean
  className?: string
  style?: React.CSSProperties
} & React.SVGProps<SVGSVGElement>) => {
  const [shouldUseImage, setShouldUseImage] = useState<'loading' | boolean>(
    'loading'
  )
  const intl = useIntl()
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase()
    const isSafari = !!userAgent.match(/safari/i) && !userAgent.match(/chrome/i)
    const isFirefox = !!userAgent.match(/firefox/i)

    const isMobile =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent
      )
    setShouldUseImage(isSafari || isFirefox || isMobile)
  }, [])

  if (shouldUseImage === 'loading') {
    return null
  }
  if (shouldUseImage === true) {
    let imageUrl = ''

    switch (type) {
      case 'simple-blue-pink':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/85d5abe2decf4bdfdaacabda238beb0cde5e620d-1602x1139.png'
        break
      case 'blue-sphere-top':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/0ac5ec88e10c0a0da6aa1706d06fb593cd6f60d5-2127x1014.png'
        break
      case 'cut-blue-sphere-top':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/8ed60f055a564c2a4d57c755aeed8d6372efab48-1439x1185.png'
        break
      case 'blue-orange-sphere-left-top':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/19414bcc9482dadccc094a604d561c251bf75297-1434x1442.png'
        break
      case 'messy-horizontal':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/a9448a7ce95e55611ef7d4f0ae95b7a092bf37ac-1500x891.png'
        break
      case 'blue-sphere-right-top':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/4137a9bd74ee9648f9bdf0d19b9f649f030ab9d5-717x558.png'
        break
      case 'blue-pink-sphere-center':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/f5ec5bedc0ee858f39b5f4ffa892a786af091b93-2949x2465.png'
        break
      case 'simple-blue':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/b535cddde57f284ad75badb4b5bc4f882e99a759-2254x1372.png'
        break
      case 'simple-beige':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/93b244e6e4e6cf03783b420cc27288235cba6412-2211x1415.png'
        break
      case 'simple-turquoise':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/8e171ce94ea2e1305be366cdb8864c93d73d3c5d-2085x1458.png'
        break
      case 'vibrant-white-pink-in-blue':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/c1d33d2de60decf91b2d7a7fc0793025c9763872-1972x2073.png'
        break
      case 'white-pink-blue-spheres':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/1725acf863b2cfbf33ea61bbead9e16cd9a8529f-2015x1467.png'
        break
      case 'blue-pink-in-orange':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/63dfb804fd2f7b1c1ea0b9f6cb4de4787f07aa3a-1256x1187.png'
        break
      case 'orange-in-blue-masked':
        imageUrl =
          'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/images/21bb0a85db405114247da1f360a18e3b91203cfc-1440x1444.png'
        break
      default:
        break
    }

    return (
      <img
        src={imageUrl}
        alt={intl.formatMessage({
          id: 'components.superbg.altImg',
          defaultMessage: 'Super background',
        })}
        className={className}
        style={{ maxWidth: 'none', ...style }}
      />
    )
  }

  const svgProps = {
    style,
    className,
    ...props,
  }
  switch (type) {
    default:
      return null
    case 'simple-blue-pink':
      return <SimpleBluePink svgProps={svgProps} hideGrain={hideGrain} />
    case 'blue-sphere-top':
      return <BlueSphereTop svgProps={svgProps} hideGrain={hideGrain} />
    case 'cut-blue-sphere-top':
      return <CutBlueSphereTop svgProps={svgProps} hideGrain={hideGrain} />
    case 'blue-orange-sphere-left-top':
      return (
        <BlueOrangeSphereLeftTop svgProps={svgProps} hideGrain={hideGrain} />
      )
    case 'messy-horizontal':
      return <MessyHorizontal svgProps={svgProps} hideGrain={hideGrain} />
    case 'blue-sphere-right-top':
      return <BlueSphereRightTop svgProps={svgProps} hideGrain={hideGrain} />
    case 'blue-pink-sphere-center':
      return <BluePinkSphereCenter svgProps={svgProps} hideGrain={hideGrain} />
    case 'vibrant-pink-in-blue':
      return <VibrantPinkInBlue svgProps={svgProps} />
    case 'simple-blue':
      return <SimpleBlue svgProps={svgProps} />
    case 'simple-beige':
      return <SimpleBeige svgProps={svgProps} />
    case 'simple-turquoise':
      return <SimpleTurquoise svgProps={svgProps} />
    case 'vibrant-white-pink-in-blue':
      return <VibrantWhitePinkInBlue svgProps={svgProps} />
    case 'white-pink-blue-spheres':
      return <WhitePinkBlueSpheres svgProps={svgProps} />
    case 'orange-in-blue-masked':
      return <OrangeInBlueMasked svgProps={svgProps} />
    case 'blue-pink-in-orange':
      return <BluePinkInOrange svgProps={svgProps} />
  }
}
